import { arrayOf, bool, func, shape } from 'prop-types';
import React from 'react';

import InvoiceModalContent from '../../balance/BalanceModal/InvoiceModalContent';
import TaskStatus, { TASK_STATUSES } from '../../generic/TaskStatus';
import {
  bookingEntryShape,
  campaignShape,
  detailedInvoiceShape,
  opportunityShape,
  productShape,
  taskShape,
} from '../../prop-types';
import api from '../../REST/api';
import withResolved from '../../REST/with-resolved';

class ProjectInvoiceForm extends React.Component {
  componentDidMount() {
    const { initialized, onInitialize, opportunity } = this.props;

    if (!initialized) {
      onInitialize({
        opportunityId: opportunity.id,
        latestTask: opportunity.latestTask,
      });
    }
  }

  handleUpdateTaskStatus = task => {
    this.props.onUpdateLatestTask(task);

    if (task.status === TASK_STATUSES.SUCCESS) {
      this.props.onReloadBookingEntries(this.props.opportunity.id);
    }
  };

  render() {
    const { latestTask } = this.props;
    return (
      <>
        <InvoiceModalContent {...this.props} />
        {latestTask && (
          <TaskStatus
            task={latestTask}
            taskName="Generation of booking entries"
            onUpdateTaskStatus={this.handleUpdateTaskStatus}
          />
        )}
      </>
    );
  }
}

ProjectInvoiceForm.propTypes = {
  opportunity: opportunityShape.isRequired,
  bookingEntries: arrayOf(bookingEntryShape.isRequired).isRequired,
  invoices: arrayOf(detailedInvoiceShape.isRequired).isRequired,
  initialized: bool.isRequired,
  onInitialize: func.isRequired,
  onDeleteBookingEntry: func.isRequired,
  onDeleteInvoice: func.isRequired,
  onUpdateLatestTask: func.isRequired,
  onReloadBookingEntries: func.isRequired,
  loading: bool.isRequired,
  staticData: shape({
    products: arrayOf(productShape.isRequired).isRequired,
    campaign: campaignShape,
  }).isRequired,
  latestTask: taskShape,
  isEditing: bool.isRequired,
};

ProjectInvoiceForm.defaultProps = {
  latestTask: null,
};

export default withResolved({
  query: campaignId =>
    Promise.all([
      api.getProducts(),
      campaignId ? api.getCampaign({ id: campaignId }) : null,
    ]).then(([products, campaign]) => ({ products, campaign })),
  deriveQueryArgs: ({ opportunity }) => opportunity.campaignId,
  as: 'staticData',
})(ProjectInvoiceForm);
